import React from 'react';
import {appGetUrlPath} from '../function_lib/common_cms';
import './image_slider.css';
import '../assets/css/magnific-popup.css';
import '../assets/js/jquery.magnific-popup.js';

export const Image_Slider_n=(props)=>{
    let appUrtPath=appGetUrlPath();
  let title="";
  if(props.lsData.length!=0){
  title=props.lsData[0]["g_title"];
  }
  
      let appPath=appGetUrlPath();
  //var listData=JSON.parse(lsData);
  let strResp="";
  
  return(<div class="main-blog-area pt11-50px pb11-50px">
    <div class="container">
        {title!=="NA"?
        <div class="row">
            <div class="col-md-12">
                <div class="heading page__title-bar">
                    <h3 class="title">{title}</h3>
                </div>
            </div>
        </div>:''}
        <div class="new-product-slider swiper-container slider-nav-style-1">
        <div class="new-product-wrapper swiper-wrapper">
  {/* content */}
  {props.lsData.map((item,index)=>{
    let hrefUrl="javascript:void(0)";
    if(item["col7"]!==""){
        hrefUrl=item["col7"];
    }
    var urlTitle= item["col1"];
    urlTitle=urlTitle.replace("?","_");
    urlTitle=urlTitle.replace(" ","-");
    return(<div class="single-blog swiper-slide">
      <div class="blog-image">{
         <a href={appUrtPath+item["col4"]} class="gallery-item image">
         <img class="img-thumbnail" src={appUrtPath+item["col4"]} alt="Product" />
         {/* <img class="img-thumbnail hover-image" src={appUrtPath+item["col4"]} alt="Product" /> */}
     </a>
      }</div>
      {item["col1"].trim()!==""?
      <div class="blog-text">
          <p class="blog-detail-text\"><b>{urlTitle}</b></p>
      </div>:''}
  </div>
      )
  })}
  {/* end of content */}
  
        </div>
  <div class="swiper-buttons">
  <div class="swiper-button-next"></div>
  <div class="swiper-button-prev"></div>
  </div>
  </div></div></div>
          )
  
  }
 
export const Image_Slider=(props)=>{
   let clsName="new-product-slider"
    let lsData=props.lsData;
//alert("i m in ma "+JSON.stringify(lsData));
    clsName="blog-slider";
    var title="";
if(lsData.length!=0){
//title=lsData[0]["g_title"];
}
//var appPath=appGetUrlPath();
var appPath="../";
//let appPath=appGetUrlPath();
//var listData=JSON.parse(lsData);
var strResp="";


    return(<div  class="main-blog-area bg-area1 pt-10px">
    <div class="container">
        <div class="row">
            <div style={{"text-align":"center"}} class="col-md-12">
                <div style={{"display":"inline-block"}} class="flag bottom-boder heading section-heading  page__title-bar">
                    
                </div>
            </div>
        </div>
        <div class={clsName+" swiper-container slider-nav-style-1"} data-slides-per-view="3">
        <div class="new-product-wrapper swiper-wrapper">
            {/* content part */}
            {lsData.map((item,index)=>{
                let hrefUrl="javascript:void(0)";
                if(item["col7"]!==""){
                    hrefUrl=item["col7"];
                }
                var urlTitle= item["col1"];
                urlTitle=urlTitle.replace("?","_");
                urlTitle=urlTitle.replace(" ","-");

                return(<div class="single-blog swiper-slide">
                <a href={hrefUrl}>
                <img style={{"width":"100%"}} src={appPath+item["col4"]}  alt="feature_expo"/>
                <div class="blog-image">
                
                </div>
            </a></div>)

            })}

            {/* end of Content Part */}
        </div>
<div class="swiper-buttons">
<div class="swiper-button-next"></div>
<div class="swiper-button-prev"></div>
</div>
</div></div></div>
            )

   
}
export default Image_Slider;